import { render, staticRenderFns } from "./mainPage.template.vue?vue&type=template&id=4345969b&scoped=true&"
var script = {}
import style0 from "./mainPage.template.vue?vue&type=style&index=0&id=4345969b&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4345969b",
  null
  
)

export default component.exports